import {all, call, fork, put, takeEvery, delay } from 'bukku/shared/SagaService';
import actions from './actions';
import {get, patch} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.MINIPOS_READ_SETTINGS_SUCCESS,
    actions.MINIPOS_UPDATE_SETTINGS_SUCCESS,
    actions.MINIPOS_READ_ALL_ORDERS_SUCCESS,
    actions.MINIPOS_READ_ORDER_SUCCESS,
    actions.MINIPOS_VOID_ORDER_SUCCESS,
];
const errorKeys = [
    actions.MINIPOS_READ_SETTINGS_ERROR,
    actions.MINIPOS_UPDATE_SETTINGS_ERROR,
    actions.MINIPOS_READ_ALL_ORDERS_ERROR,
    actions.MINIPOS_READ_ORDER_ERROR,
    actions.MINIPOS_VOID_ORDER_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.MINIPOS_UPDATE_SETTINGS_SUCCESS:
            return t`The settings are updated.`;
        case actions.MINIPOS_VOID_ORDER_SUCCESS:
            return t`The order is marked as void.`;
        default:
            return null;
    }
};

const useDummyData = false;

function* readMiniPosSettingsRequest() {
    yield takeEvery(actions.MINIPOS_READ_SETTINGS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* () {
                if (useDummyData) {
                    yield delay(100);
                    yield put({
                        type: actions.MINIPOS_READ_SETTINGS_SUCCESS,
                        settings: {
                            receipt_footer_message: "Thank you and have a nice day!",
                            receipt_header_message: "Welcome to My Store",
                            receipt_show_customer_info: false,
                            receipt_show_logo: true,
                            store_name: "My Store",
                        },
                    });
                }
                else {
                    const response = yield call(get, `/minipos/settings`, null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MINIPOS_READ_SETTINGS_SUCCESS,
                        settings: data.settings,
                    });
                }
            });
    });
}

function* updateMiniPosSettingsRequest() {
    yield takeEvery(actions.MINIPOS_UPDATE_SETTINGS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    yield put({
                        type: actions.MINIPOS_UPDATE_SETTINGS_SUCCESS,
                        settings: {
                            receipt_footer_message: request.receipt_footer_message,
                            receipt_header_message: request.receipt_header_message,
                            receipt_show_customer_info: request.receipt_show_customer_info,
                            receipt_show_logo: request.receipt_show_logo,
                            store_name: request.store_name,
                        },
                    });
                }
                else {
                    const response = yield call(patch, `/minipos/settings`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MINIPOS_UPDATE_SETTINGS_SUCCESS,
                        settings: data.settings,
                    });
                }
            });
    });
}

function* readAllMiniPosOrdersRequest() {
    yield takeEvery(actions.MINIPOS_READ_ALL_ORDERS_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MINIPOS_READ_ALL_ORDERS_SUCCESS,
                        pagination: {
                            total: 4,
                            current_page: 1,
                            per_page: request.page_size || 30,
                        },
                        orders: [{
                            id: 1,
                            customer_name: "John Doe",
                            number: "SO-1111-202411220003",
                            amount: 7,
                            myinvois_action: "NORMAL",
                            status: "ready",
                            created_at: "2024-05-09 17:59:26",
                            updated_at: "2024-05-09 18:03:36",
                        }, {
                            id: 2,
                            customer_name: "John Smith",
                            number: "SO-1122-202411220004",
                            amount: 30,

                            // myinvois_action: "VALIDATE",
                            // myinvois_document_status: "VALID",

                            myinvois_action: "VALIDATE",
                            myinvois_document_id: 433,
                            myinvois_document_status: "VALID",
                            myinvois_document_uuid: "CKNCMQS5KYC6NP0M0PJWNDBJ10",
                            issued_at: "2024-11-24 00:00:00",
                            validated_at: "2024-11-24 21:27:57",

                            status: "ready",
                            created_at: "2024-05-10 11:03:26",
                            updated_at: "2024-05-10 11:03:26",
                        },
                        {
                            id: 3,
                            customer_name: "Nara Smith",
                            number: "SO-1123",
                            amount: 12.99,
                            myinvois_action: "VALIDATE",
                            myinvois_document_status: "INVALID",
                            status: "ready",
                            created_at: "2024-05-10 11:03:26",
                            updated_at: "2024-05-10 11:03:26",
                            validated_at: "2024-10-10 16:04:37",
                        },
                        {
                            id: 4,
                            customer_name: "Cash Sales",
                            number: "SO-1124",
                            amount: 23.49,
                            myinvois_action: "NORMAL",
                            myinvois_document_status: null,
                            status: "void",
                            created_at: "2024-05-10 11:03:26",
                            updated_at: "2024-05-10 11:03:26",
                        },
                        ],
                    });
                }
                else {
                    const response = yield call(get, `/minipos/orders`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MINIPOS_READ_ALL_ORDERS_SUCCESS,
                        orders: data.orders,
                        pagination: data.paging,
                    });
                }
            });
    });
}

function* readMiniPosOrderRequest() {
    yield takeEvery(actions.MINIPOS_READ_ORDER_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                if (useDummyData) {
                    yield delay(100);
                    // OK
                    yield put({
                        type: actions.MINIPOS_READ_ORDER_SUCCESS,
                        order: {
                            id: 1,
                            customer_id: 1,
                            customer_name: "Adam Wong Cheng Kiat",
                            number: "SO-1111-202411220003",
                            amount: 7,

                            // myinvois_action: "VALIDATE",
                            // myinvois_document_id: 433,
                            // myinvois_document_status: "VALID",
                            // myinvois_document_uuid: "CKNCMQS5KYC6NP0M0PJWNDBJ10",
                            // issued_at: "2024-11-24 00:00:00",
                            // validated_at: "2024-11-24 21:27:57",

                            myinvois_action: "NORMAL",

                            status: "ready",

                            // status: "void",
                            // voided_at: "2024-05-09 18:03:36",
                            // void_reason: "slay",
                            created_at: "2024-05-09 17:59:26",
                            updated_at: "2024-05-09 18:03:36",

                            products: [
                                {
                                    product_name: "Product name",
                                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce et mi ac tortor facilisis facilisis. Vivamus semper tellus odio, id ullamcorper leo vulputate vitae. Quisque ut sollicitudin dui. Donec erat tellus, vulputate pretium velit a, tempor tempus ligula. Sed vitae egestas urna. Pellentesque eget elit velit. Donec hendrerit gravida euismod",
                                    product_id: 118,
                                    sale_price: 3.5,
                                    quantity: 2,
                                    amount: 70.99,
                                },
                                {
                                    product_name: "Product name 2",
                                    description: "Product description 2",
                                    product_id: 11,
                                    sale_price: 3.5,
                                    quantity: 2,
                                    amount: 89.12,
                                },
                            ],
                            remarks: "The very first order",
                            payment_method: "Cash",
                            payment_reference_no: null,
                        },
                    });
                }
                else {
                    const response = yield call(get, `/minipos/orders/${id}`, null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MINIPOS_READ_ORDER_SUCCESS,
                        order: data.order,
                    });
                }
            });
    });
}

function* voidMiniPosOrderRequest() {
    yield takeEvery(actions.MINIPOS_VOID_ORDER_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                if (useDummyData) {
                    yield delay(100);
                    yield put({
                        type: actions.MINIPOS_VOID_ORDER_SUCCESS,
                        status: "void",
                        order: {},
                    });
                }
                else {
                    const response = yield call(patch, `/minipos/orders/${id}`, request, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.MINIPOS_VOID_ORDER_SUCCESS,
                        order: data.order,
                        status: data.order.status,
                    });
                }
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(readMiniPosSettingsRequest),
        fork(updateMiniPosSettingsRequest),
        fork(readAllMiniPosOrdersRequest),
        fork(readMiniPosOrderRequest),
        fork(voidMiniPosOrderRequest),
    ]);
}
